import { Badge, Box, Stack, Typography } from "@mui/material";
import { GREY, MAIN_COLOR, WHITE } from "../style/theme";
import { URow, USection } from "../common/ui.page";
import { BoxCut } from "./wh.ui.cut";
import { ParallaxBox } from "../common/ui.parallax";
import { UIcon } from "../common/ui.icon";
import { WCodexIcon } from "./wh.ui.icons";
import { useContext } from "react";
import { PageContext } from "../common/pages";


export function CPageTitle(props) {
    const { children, title, icon, ...rest } = props;
    return <Stack  {...rest}>
        <Typography sx={{ fontSize: 12, color: GREY[700], fontWeight: 600, lineHeight: 1 }}>
            {title}</Typography>
        <Typography sx={{ fontWeight: 500 }}>{children}</Typography>
    </Stack>
}

export function CPageTop(props) {
    const { primary, secondary, codex, alert, ...rest } = props;
    const cmdPage = useContext(PageContext)

    // <ParallaxBox image="/static/bg/bg-fw-0.png">
    return <Box>
        <Stack justifyContent="end" sx={{ minHeight: 46, paddingBottom: 1, ...rest.sx }}>
            <USection>
                <Typography sx={{
                    fontWeight: 500,
                    lineHeight: 1.1,
                    fontSize: 12,
                    color: GREY[700],
                }}>{secondary}</Typography>
            </USection>
        </Stack>
        <USection>
            <Box sx={{ position: 'relative' }}>
                <Box onClick={() => cmdPage.setPage('crusade')} sx={{
                    position: 'absolute',
                    right: 0,
                    top: -30,
                }}>
                    <Badge
                        color="warning"
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }} badgeContent={alert}>
                        <WCodexIcon size={48} name={codex} />
                    </Badge>
                </Box>
            </Box>
        </USection>
        <BoxCut cutSize={54} sx={{ backgroundColor: GREY[100], height: 24 }}>
            <USection >
                <URow>
                    {primary && <Typography sx={{ color: GREY[800], fontSize: 14 }}>{primary}</Typography>}
                    {props.children}
                    <Box sx={{ flexBasis: '50px' }}></Box>
                </URow>
            </USection>
        </BoxCut>
    </Box>
}

export function CPage(props) {
    return <Stack sx={{ paddingBottom: 20 }}>

        {props.children}
    </Stack>

}

export function CSection(props) {
    return <USection {...props} sx={{
        background: GREY[100],
        paddingTop: 4,
        paddingBottom: 4,
        ...props.sx,
    }} />
}